import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginGuard} from '../guards/login.guard';
import {PermissionGuard} from '../guards/permission.guard';

export const appRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'dashboard', path: '/app/dashboard' }
  },
  {
    path: 'users',
    loadComponent: () => import('./users/listUsers/listUsers.component').then(m => m.ListUsersComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'users' }
  },
  {
    path: 'users/add',
    loadComponent: () => import('./users/createusers/createusers.component').then(m => m.CreateusersComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'users' }
  },
  {
    path: 'users/update/:id',
    loadComponent: () => import('./users/createusers/createusers.component').then(m => m.CreateusersComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'users' }
  },
  {
    path: 'clients',
    loadComponent: () => import('./clients/listClients/listClients.component').then(m => m.ListClientsComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'clients' }
  },
  {
    path: 'products',
    loadComponent: () => import('./products/listProducts/listProducts.component').then(m => m.ListProductsComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'products' }
  },
  {
    path: 'inventory',
    loadComponent: () => import('./inventory/list-inventory/list-inventory.component').then(m => m.ListInventoryComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'inventory' }
  },
  {
    path: 'expenses',
    loadComponent: () => import('./finance/list-expenses.component').then(m => m.ListExpensesComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'expenses' }
  },
  {
    path: 'expense-categories',
    loadComponent: () => import('./finance/list-expense-categories.component').then(m => m.ListExpenseCategoriesComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'expenses' }
  },
  {
    path: 'suppliers',
    loadComponent: () => import('./finance/list-suppliers.component').then(m => m.ListSuppliersComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'suppliers' }
  },
  {
    path: 'payables',
    loadComponent: () => import('./finance/list-payables.component').then(m => m.ListPayablesComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'payables' }
  },
  {
    path: 'treasury',
    loadComponent: () => import('./finance/list-treasury.component').then(m => m.ListTreasuryComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'treasury' }
  },
  {
    path: 'cash-flow',
    loadComponent: () => import('./finance/cash-flow-dashboard.component').then(m => m.CashFlowDashboardComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'cash-flow' }
  },
  {
    path: 'warehouses',
    loadComponent: () => import('./warehouses/list-warehouses/list-warehouses.component').then(m => m.ListWarehousesComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'warehouses' }
  },
  {
    path: 'quotes',
    loadComponent: () => import('./quotes/list-quotes/list-quotes.component').then(m => m.ListQuotesComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'quotes' }
  },
  {
    path: 'orders',
    loadComponent: () => import('./orders/list-orders/list-orders.component').then(m => m.ListOrdersComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'orders' }
  },
  {
    path: 'invoices',
    loadComponent: () => import('./invoices/list-invoices/list-invoices.component').then(m => m.ListInvoicesComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'invoices' }
  },
  {
    path: 'purchase-requests',
    loadComponent: () => import('./purchase-requests/list-purchase-requests/list-purchase-requests.component').then(m => m.ListPurchaseRequestsComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'purchase-requests' }
  },
  {
    path: 'production-orders',
    loadComponent: () => import('./production-orders/list-production-orders/list-production-orders.component').then(m => m.ListProductionOrdersComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'production-orders' }
  },
  {
    path: 'production-orders/:id',
    loadComponent: () => import('./production-orders/detail-production-order/detail-production-order.component').then(m => m.DetailProductionOrderComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'production-orders' }
  },
  {
    path: 'collections',
    loadComponent: () => import('./collections/list-collections-portfolio/list-collections-portfolio.component').then(m => m.ListCollectionsPortfolioComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'collections' }
  },
  {
    path: 'profiles',
    loadComponent: () => import('./profiles/list-profiles/list-profiles.component').then(m => m.ListProfilesComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'profiles' }
  },
  {
    path: 'reports',
    loadComponent: () => import('./reports/sales-reports/sales-reports.component').then(m => m.SalesReportsComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'reports' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'sales-by-date'
      },
      {
        path: 'sales-by-date',
        loadComponent: () => import('./reports/sales-by-date/sales-by-date.component').then(m => m.SalesByDateComponent),
        canActivate: [LoginGuard, PermissionGuard],
        data: { permission: 'reports' }
      },
      {
        path: 'sales-by-seller',
        loadComponent: () => import('./reports/sales-by-seller/sales-by-seller.component').then(m => m.SalesBySellerComponent),
        canActivate: [LoginGuard, PermissionGuard],
        data: { permission: 'reports' }
      }
    ]
  },
  {
    path: 'kanban',
    loadComponent: () => import('./kanban/kanban-board/kanban-board.component').then(m => m.KanbanBoardComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'kanban', path: '/app/kanban' }
  },
  {
    path: 'calendar/deliveries',
    loadComponent: () => import('./calendar/delivery-calendar/delivery-calendar.component').then(m => m.DeliveryCalendarComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'calendar', path: '/app/calendar/deliveries' }
  },
  {
    path: 'security',
    loadComponent: () => import('./security/security-settings.component').then(m => m.SecuritySettingsComponent),
    canActivate: [LoginGuard]
  },
  {
    // Ruta de soporte: intencionalmente fuera de menu.ts, solo se llega por URL.
    path: 'logs',
    loadComponent: () => import('./logs/logs.component').then(m => m.LogsComponent),
    canActivate: [LoginGuard, PermissionGuard],
    data: { permission: 'logs' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}


